import React from 'react';
import Logger from './logger';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({ hasError: true });
        Logger.error(`Component error: "${error.toString()}" Stack: ${info.componentStack}`);
    }

    render() {
        if (this.state.hasError) {
            return <div />;
        }
        return this.props.children;
    }
}
